
<template>
  <div>
    <v-dialog v-if="saving" persistent max-width="500px" transition="dialog-transition" >
      Salvando... 
      <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="1000px" transition="dialog-transition">
      <template v-slot:activator="{on}">
        <v-tooltip v-on="on" top color="black">
          <template v-slot:activator="{on}">
            <v-btn v-on="on" icon color="success" class='ma-1' small :disabled="loading" @click="dialog = true"><v-icon>mdi-check-circle</v-icon></v-btn>
          </template>
          Validar
        </v-tooltip>
        <!-- <v-btn v-on="on" color="primary" icon small class="mx-0 my-1" ><v-icon small>fa-pen</v-icon></v-btn> -->
        <!-- <v-btn v-if="btn_kind == 'btn'" v-on="on" color="primary" round small ><v-icon small left>fa-pen</v-icon>retornado</v-btn> -->
        <!-- <v-btn v-if="btn_kind == 'fab'" v-on="on" color="primary" fab small ><v-icon small>fa-pen</v-icon></v-btn> -->
      </template>

      <v-card v-if="dialog" style="border-radius: 8px">
        <v-card-title primary-title>
          <div class="headline mb-0">Validando cheque retornado</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="title">Cheques semelhantes</div>
          <v-alert type="info" :value="true" v-if="loading">
            Carregando... 
            <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
          </v-alert>
          <template v-if="!loading && !similars.length">
            <v-alert type="success" :value="true">
              Sem nehum cheque semelhante!
            </v-alert>
          </template>
          <template v-if="!loading && similars.length">
            <v-alert type="error" :value="true">
              Para continuar, primeiro certifique que não há nenhum cheque semelhante.
            </v-alert>

            <v-data-table
              ref="table"
              :headers="headers"
              :items="similars"
              class="elevation-0"
              :loading="loading"
              mobile-breakpoint="1"
            >
              <template v-slot:item.value="{item}">
                {{ Number(item.value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
              </template>
              <template v-slot:item.solution="{item}">
                {{ solution_map[item.solution] || '--' }}
              </template>
              <template v-slot:item.status="{item}">
                <v-chip outlined small color='success'>
                  <v-avatar left>
                    <v-icon small>{{status_map[item.status].icon}}</v-icon>
                  </v-avatar>
                  <b>{{status_map[item.status].text}}</b>
                </v-chip>
              </template>
            </v-data-table>

            <v-checkbox label="Estou atento ao alerta de cheques semelhantes e vou confirmar mesmo assim" v-model="know_similars" :value="true"></v-checkbox>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <f-btn cancel @click="dialog=false"></f-btn>
          <f-btn save @click="confirmReturned()" :disabled="disabled"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';
import SolutionMap from '@/_backoffice/_registrations/mixins/solution_map.js'

export default {
  name: "DialogConfirmReturned",
  mixins: [SolutionMap],
  props: {
    check: {
      type: Object,
    },
  },
  data() {
    return {
      dialog: null,
      loading: false,
      saving: false,
      similars: [],
      know_similars: false,

      status_map: {
        to_confirm: {
          icon: 'mdi-progress-clock',
          text: 'A confirmar',
        },
        confirmed: {
          icon: 'mdi-check',
          text: 'Validado',
        },
        in_hands: {
          icon: 'mdi-account-cash-outline',
          text: 'Em mãos',
        },
        payed: {
          icon: 'mdi-cash-check',
          text: 'Pago',
        },
        sent: {
          icon: 'mdi-send',
          text: 'Enviado',
        },
      },

      headers: [
        {text: '#', value: 'id', sort: 'desc'},
        {text: 'Número',  value: 'number'},
        {text: 'Motivo',  value: 'motive'},
        {text: 'Valor',      value: 'value'},
        {text: 'Nome local', value: 'place_name'},
        {text: 'Status', value: 'status'},
      ],
    }
  },
  methods: {
    confirmReturned(){
      let obj = {id: this.check.id, status: 'confirmed'}
      
      this.saving = true
      Api.ReturnedCheck.update(obj).then(r=> r.data).then(d=> {
        this.$emit('confirmed')
      }).catch((err) => {
        console.log({err});
      }).finally(()=>{
        this.saving = false
      })
    },
    getSimilars() {
      let filter = {
        is_similar: true,
        similar_id: this.check.id,
        by_place_ids: [this.check.place_id]
      }
      this.loading = true
      Api.ReturnedCheck.index(filter).then(r=>r.data).then(d=> {
        d = d.data? d.data.map(b=> b.attributes) : d
        this.similars = [...d]
      }).catch((err) => {
        console.log(err);
      }).finally(()=>{
        this.loading = false
      })
    },
    handleDoneComment(){
      this.getSimilars()
    },
  },
  computed: {
    disabled() {
      return (this.loading || this.similars.length>0) && !this.know_similars 
    },
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
        this.getSimilars()
      } else if (nv == false){
        this.similars = []
        this.know_similars = false
      }
    }
  },
}
</script>

<style scoped>

</style>